import { render, staticRenderFns } from "./boxAdd.vue?vue&type=template&id=4d76d682&scoped=true"
import script from "./boxAdd.vue?vue&type=script&lang=js"
export * from "./boxAdd.vue?vue&type=script&lang=js"
import style0 from "./boxAdd.vue?vue&type=style&index=0&id=4d76d682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d76d682",
  null
  
)

export default component.exports